module.exports = __webpack_public_path__ + "media/images/application/icons/logout-5774a39a6f2124155182755d40d9b932.svg";